import router from "../router";
import ApiService from "./api.service";
import { TokenService } from "./storage.service";
import { encryptCredential } from "./credentialEncryption";

class AuthencationError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode;
  }
}

const UserService = {
  /**
   * Login the user and store the access token to TokenService.
   *
   * @returns access_token
   * @throws AuthenticationError
   **/

  login: async function(email, password, device_token) {
    let encryptedPassword;
    try {
      encryptedPassword = await encryptCredential(password);
    } catch (error) {
      const wrapped = new Error("Unable to secure login. Try again.");
      wrapped.response = {
        data: { message: "Unable to secure login. Try again." }
      };
      throw wrapped;
    }

    const requestData = {
      method: "post",
      url: "auth/axolenght/login",
      data: {
        email: email,
        password: encryptedPassword,
        device_token: device_token
      }
    };
    try {
      const response = await ApiService.customRequest(requestData);
      console.log(response);

      return response;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  verifyOtp: async function(otp, phone_number , elantro, device_token) {
    const requestData = {
      method: "post",
      url: "auth/axolenght/login/otp",
      data: {
        otp: otp,
        phone_number: phone_number,
        expoxifier : elantro,
        device_token: device_token
      }
    };
    try {
      const response = await ApiService.customRequest(requestData);
      TokenService.saveToken(response.data.data.auth_token);
      ApiService.setHeader();

      return response;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  /**
   * Logout the current user by removing the token from storage.
   *
   * Will also remove `Authorization Bearer <token>` header from future requests.
   **/
  logout() {
    TokenService.removeToken();
    TokenService.removeUser();
    TokenService.removeAdminProfile();
    TokenService.removePermissions();
    TokenService.removeRefreshToken();
    TokenService.removeExpiredTokenTime();
    ApiService.removeHeader();
    router.push({ name: "Login" });
  },
  getUser: async function() {
    try {
      const response = await ApiService.get("/user");
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  updateUser: async function(payload) {
    try {
      const response = await ApiService.post("/update-user", payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export { UserService, AuthencationError };
